/**
 * Key IDs.
 *
 * @group DRM
 *
 * @beta
 */
export const KEYIDS = 'keyids';
